import React from "react";

import Image from "next/image";

import cloudImg from "@/app/assets/illustration/2 does this sound familiar/webp/cloud.webp";

export const CloudBreak = () => {
    return (
        <div className="w-full md:py-6 py-4">
            <Image alt="Cloud decoration" className="md:block hidden mx-auto" src={cloudImg} width={160} />
        </div>
    );
};
